import { normalizeUnreachableAfterDays } from '../adressHelpers/unreachableAfterDays'

// AI-CONTEXT: See docs/features/household-overview-table-and-statuses.md
// Mag dit huishouden op 'Onbereikbaar' gezet worden?
//
// De oude regel was alleen "drie mislukte pogingen op rij" — drie keer bellen
// op één ochtend haalde die drempel al, en zo belandden mensen te snel op
// onbereikbaar. Er komt een wachttijd bij, geteld vanaf de EERSTE mislukte
// poging van de reeks: vanaf de laatste tellen zou de klok terugzetten bij elke
// nieuwe poging, waardoor een huishouden waar actief achteraan gebeld wordt
// nooit in aanmerking komt.
//
// Blijft een oordeel dat een medewerker zelf velt: deze functie bepaalt alleen
// of de knop verschijnt, niet of de status verandert (ADR-019).

const MINIMUM_FAILED_STREAK = 3

const MS_PER_DAY = 1000 * 60 * 60 * 24

/**
 * @param {object} [input]
 * @param {number} [input.streak] - Mislukte pogingen op rij (computeFailedStreakDetails)
 * @param {{toDate: () => Date}|null} [input.firstFailedAt] - Begin van die reeks
 * @param {*} [input.afterDays] - CompagnyMeta.UnreachableAfterDays; ontbreekt hij, dan de standaard
 * @param {Date} [input.now] - Peilmoment, injecteerbaar voor tests
 * @returns {boolean}
 */
const isUnreachableEligible = ({ streak, firstFailedAt, afterDays, now = new Date() } = {}) => {
    if (!Number.isFinite(streak) || streak < MINIMUM_FAILED_STREAK) return false
    if (typeof firstFailedAt?.toDate !== 'function') return false

    const startedMs = firstFailedAt.toDate().getTime()
    if (Number.isNaN(startedMs)) return false

    const elapsedDays = (now.getTime() - startedMs) / MS_PER_DAY

    return elapsedDays >= normalizeUnreachableAfterDays(afterDays)
}

export default isUnreachableEligible
export { MINIMUM_FAILED_STREAK }
